import { Col, Progress, Row, Spin } from "antd";
import { useEffect, useState } from "react";
import { getDashboardApi } from "mock/dashboardDemoData";
import moment from "moment";

const EducationAndTrainingOverview = () => {

    const [educationAndOverviewData, setEducationAndOverviewData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const clientId = localStorage.getItem("client_id")

    useEffect(() => {
        let isMounted = true;
        
        const fetchData = async () => {
            if (isMounted) setIsLoading(true);
            try {
                const { error, result } = await getDashboardApi(`/get_education_count_by_client?client_id=${clientId}&date=${moment().format("YYYY-MM")}`);
                if (!error && isMounted) {
                    console.log('Education Training API Response:', result);
                    // API returns {success, message, result}, so we need result.result
                    // with no data the API answers something other than a list
                    setEducationAndOverviewData(Array.isArray(result?.result) ? result.result : []);
                }
            } catch (err) {
                console.error('Error fetching education training overview:', err);
            } finally {
                if (isMounted) setIsLoading(false);
            }
        };
        
        if (clientId) {
            fetchData();
        } else {
            setIsLoading(false);
        }
        
        return () => {
            isMounted = false;
        };
    }, [clientId]);

    return (
        <div className="title-container">
            <div className="mb-3">
                Education and Training Overview
            </div>

            <div className="dashboard-overview-container">
                {
                    isLoading ? (
                        <div style={{ height: "200px", width: "100%" }} className="d-flex justify-content-center align-items-center">
                            <Spin />
                        </div>
                    ) : educationAndOverviewData.length === 0 ? (
                        <div style={{ height: "200px", width: "100%", color: "#666" }} className="d-flex justify-content-center align-items-center">
                            No education data for this month
                        </div>
                    ) : (
                        <Row gutter={[15]}>
                            {educationAndOverviewData.map(
                                (data) => {
                                    if (data.education_type == "Monthly Education") {
                                        return (
                                            <Col span={24} key={data.education_type}>
                                                <div className="education_training_overview_main">
                                                    <div className="percentage_box">
                                                        {data.submission_percentage}
                                                    </div>
                                                    <div className="percentage_box_2">
                                                        <div className="percentage_sign">%</div>
                                                        <div>Completed Monthly</div>
                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    }
                                }
                            )}

                            {educationAndOverviewData.map(
                                (data, index) => {
                                    return (
                                        <Col span={6} key={index}>
                                            <div className="progress_main">
                                                <div className="progress_label">
                                                    {data.education_type ==
                                                        "Tool Box Education"
                                                        ? "Toolbox"
                                                        : data.education_type ==
                                                            "Monthly Education"
                                                            ? "Monthly"
                                                            : data.education_type}
                                                </div>
                                                <div className="progress_bar">
                                                    <Progress
                                                        percent={Number(
                                                            (data.submission_count /
                                                                data.total_user_count) *
                                                            100
                                                        )}
                                                        showInfo={false}
                                                    />
                                                </div>
                                                <div className="progress_number">
                                                    {data.education_type ==
                                                        "Monthly Education"
                                                        ? `${data.submission_count}/${data.total_user_count}`
                                                        : `${data.submission_count}`}
                                                </div>
                                            </div>
                                        </Col>
                                    );
                                }
                            )}
                        </Row>
                    )
                }
            </div>
        </div>
    );
}

export default EducationAndTrainingOverview;